import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router';
import { useGetLicense, useGetSinglePage, useWindowSize } from 'react-easyrocket';
import { paymentsCards } from 'src/constants';
import { FooterWave } from 'src/components/svg/Footer';
import { AllRights } from 'src/components/svg/AllRights';
import { Wrapper } from 'src/components/Wrapper';
import Languages from 'src/modules/locales/components/Languages';
import { useRoute } from 'src/router/hooks';
import { Logo } from 'src/config/components/Logo';

export const Footer = () => {
  const { t } = useTranslation();
  const { image: licenseImage, text: licenseText } = useGetLicense();
  const { childs } = useGetSinglePage('info_pages');
  const { isDekstopLayout } = useWindowSize();
  const { ROUTE } = useRoute();

  return (
    <footer className="w-full">
      <div className="w-full min-h-[50px] max-h-[330px]">
        <FooterWave />
      </div>
      <div className="flex flex-col items-center justify-center px-2.5 relative bg-f_bg pb-[70px] r_sm:top-[-2px]">
        <Wrapper>
          <div className="flex justify-between w-full items-center gap-5 r_small:flex-col pb-[30px]">
            {isDekstopLayout && (
              <Link to={ROUTE.MAIN.get()}>
                <div className="w-auto mr-[50px]">
                  <Logo className="max-w-[250px]" />
                </div>
              </Link>
            )}
            <div className="grid grid-cols-3 gap-2.5 w-full r_small:flex r_small:flex-col r_small:items-center">
              {childs?.map((item, index) => (
                <NavLink
                  aria-label={`${t(item.title)}`}
                  to={ROUTE.INFO_PAGES_CODE.get(item.code)}
                  key={index}
                  className={({ isActive }) =>
                    isActive ? 'text-f_text_active' : 'text-f_text hover:!text-f_text_active'
                  }>
                  <p className="text-sm mb-[5px] w-auto">{t(item.title)}</p>
                </NavLink>
              ))}
              <NavLink
                to={ROUTE.FAQ.get()}
                aria-label={'Faq'}
                className={({ isActive }) =>
                  isActive ? 'text-f_text_active' : 'text-f_text hover:!text-f_text_active'
                }>
                <p className="text-sm mb-[5px] w-auto uppercase">Faq</p>
              </NavLink>
              {/*<NavLink
                className={({ isActive }) =>
                  isActive ? 'text-f_text_active' : 'text-f_text hover:!text-f_text_active'
                }
                aria-label={`${t('footer.affiliate')}`}
                target="_blank"
                to="https://boomerang-partners.com">
                <p className="text-sm mb-[5px] w-auto">{t('footer.affiliate')}</p>
              </NavLink>*/}
            </div>
            <div>
              <Languages />
            </div>
          </div>
          <div className="w-full border-t-2 border-f_separator" />
          <div className="flex flex-wrap items-center justify-center w-full my-[30px]">
            {paymentsCards.map((element, index) => (
              <div
                className="flex items-center justify-center max-w-[120px] h-[30px] px-2.5 mt-2.5"
                key={index}>
                {element.image}
              </div>
            ))}
          </div>
          <div className="w-full border-t-2 border-f_separator"></div>
          <div className="flex flex-wrap gap-5 justify-between mt-7 r_laptop:flex-col r_laptop:items-center">
            <p className="r_sm:px-2.5 not-italic font-medium text-sm text-f_text max-w-[740px] r_sm:text-[10px] r_laptop:max-w-none">
              {licenseText}
            </p>
            <div className="flex flex-col r_small:flex-col items-center justify-center 640:mb-[50px] 1024:mb-0 mb-[90px]">
              <div className="flex gap-4 mb-5">
                <div
                  dangerouslySetInnerHTML={{ __html: licenseImage }}
                  className="[&_img]:block [&_img]:h-[50px] [&_img]:w-auto"
                />
                <div className="max-w-[50px] min-w-[50px] object-contain">
                  <AllRights />
                </div>
              </div>
            </div>
          </div>
        </Wrapper>
      </div>
    </footer>
  );
};
